export default __webpack_public_path__ + "static/media/BrownLLWeb-Bold.aa0e71f4.woff";